import React, { useState } from 'react';
import './Header.css';
import axios from '../../../../../API/host';
import { useElements, useStripe, CardElement } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import LoadingBar from '../../../../../assests/Bars-1s-200px';
import StripIcon from '../../../../../assests/stripeIcon.svg';
import PaymentLogos from '../../../../../assests/paymentLogos';
const Header = () => {
	const [clientSecret, setClientSecret] = useState(true);
	const [amountSelected, setSelectedAmount] = useState(0);
	const [disabled, setDisabled] = useState(true);
	const [processing, setProcessing] = useState('');
	const [error, setError] = useState(null);
	const [succeeded, setSucceeded] = useState(false);
	const handleSetAmount = async e => {
		setError(null);
		setSelectedAmount(e.target.value);
		try {
			const response = await axios({
				method: 'post',
				url: `/api/payments/create?total=${e.target.value * 100}`,
			});
			setClientSecret(response.data.clientSecret);
		} catch (error) {
			setError('Something wrong with the server, please try again later!');
		}
	};
	const stripe = useStripe();
	const elements = useElements();
	const CARD_OPTIONS = {
		iconStyle: 'solid',

		style: {
			base: {
				iconColor: '#c4f0ff',
				color: '#fff',

				fontWeight: 500,
				fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
				fontSize: '16px',
				fontSmoothing: 'antialiased',
				':-webkit-autofill': {
					color: '#fce883',
				},
				'::placeholder': {
					color: '#87bbfd',
				},
			},
			invalid: {
				iconColor: '#ffc7ee',
				color: '#ffc7ee',
			},
		},
	};

	const handleCardinputChange = e => {
		// Listen for changes in the cardElement
		//and display any errors as the customer types thier card details

		setDisabled(e.empty);

		setError(e.error ? e.error.message : '');
	};

	const handleSubmit = async e => {
		e.preventDefault();
		if (!amountSelected) {
			setError('please select amount first');
			setSucceeded(false);
		} else {
			setProcessing(true);
			const { error } = await stripe.confirmCardPayment(clientSecret, {
				payment_method: {
					card: elements.getElement(CardElement),
				},
			});
			if (!error) {
				setSucceeded(true);
				setError(null);
				setProcessing(false);
				// elements.getElement(CardElement).clear();
			}
			if (error) {
				setSucceeded(false);
				setProcessing(false);
				setError(`${error.message} (Please reselect the the donation amount!)`);
			}
		}
	};

	return (
		<div className="header-container">
			<div className="left-col">
				<div className="content">
					<h1 style={{ fontSize: 'clamp(2rem, 2rem + 1vw, 3rem)' }}>
						Have An Idea!
					</h1>
					<p>
						The little things that makes huge difference!
						<br /> This is a custom design with{' '}
						<span style={{ fontWeight: 'bold', color: 'orange' }}>
							React
						</span>{' '}
						{''}| {''}
						<span style={{ fontWeight: 'bold', color: '#b36200' }}>
							CSS
						</span>{' '}
						{''}| {''}
						<span style={{ fontWeight: 'bold', color: '#635BFF' }}>
							Stripe.
						</span>
					</p>
				</div>
			</div>
			<div className="right-col">
				<div className="form content">
					{!succeeded && (
						<>
							<div className="input-wrapper" style={{ marginBottom: '3rem' }}>
								<p style={{ textAlign: 'center', lineHeight: 2 }}>
									<span style={{ fontSize: 'clamp(2rem, 2rem + 1vw, 3rem)' }}>
										Let's Keep It Going!
									</span>
									<br />
									Buy me a Coffee ☕☕ | IPA 🍺🍺
									<br />
									<span
										style={{
											color: 'orange',
											textTransform: 'uppercase',
											fontWeight: 'bold',
										}}
									>
										let's talk! -{' '}
										<a
											style={{ textTransform: 'capitalize' }}
											href="https://www.johnyacoub.live"
										>
											Contact Me
										</a>
									</span>
								</p>
							</div>
							<div className="input-wrapper">
								<form onSubmit={handleSubmit}>
									<fieldset className="amount-options">
										<ul>
											<li className="radiobuttons-cell input_amount_0">
												<input
													type="radio"
													name="amount"
													id="input_amount_0"
													value="2.75"
													onClick={handleSetAmount}
												/>
												<label className="frb-btn" htmlFor="input_amount_0">
													$2.75
												</label>
											</li>
											<li className="radiobuttons-cell input_amount_1">
												<input
													type="radio"
													name="amount"
													id="input_amount_1"
													value="5.00"
													onClick={handleSetAmount}
												/>
												<label className="frb-btn" htmlFor="input_amount_1">
													$5
												</label>
											</li>
											<li className="radiobuttons-cell input_amount_2">
												<input
													type="radio"
													name="amount"
													id="input_amount_2"
													value="10.00"
													onClick={handleSetAmount}
												/>
												<label className="frb-btn" htmlFor="input_amount_2">
													$10
												</label>
											</li>
											<li className="radiobuttons-cell input_amount_3">
												<input
													type="radio"
													name="amount"
													id="input_amount_3"
													value="20.00"
													onClick={handleSetAmount}
												/>
												<label className="frb-btn" htmlFor="input_amount_3">
													$20
												</label>
											</li>
										</ul>
										<div className="cardElement">
											<CardElement
												options={CARD_OPTIONS}
												onChange={handleCardinputChange}
											/>
										</div>
										{error && <div style={{ color: 'red' }}>{error}</div>}
										<CurrencyFormat
											renderText={value => (
												<h3 style={{ alignSelf: 'self-start' }}>
													Amount: {value}
												</h3>
											)}
											decimalScale={2}
											value={amountSelected}
											displayType={'text'}
											thousandSeparator={true}
											prefix={'$'}
										/>
									</fieldset>
									<button
										type="submit"
										disabled={!stripe || processing || disabled || error}
									>
										<span>{processing ? <LoadingBar /> : 'Cheers!'}</span>
									</button>
								</form>
							</div>
						</>
					)}

					{succeeded && (
						<div className="success-container">
							<h1>Thank you for the Tip!</h1>
							<a target="_self" href="https://johnyacoub.live/">
								<button>Go Back</button>
							</a>
						</div>
					)}
				</div>
				<div className="strip-footer" style={{}}>
					<p
						style={{
							fontSize: '.95em',
							// padding: '2.5rem',
							paddingRight: 0,
							position: 'relative',
						}}
					>
						<PaymentLogos />
						Payment integration done using
						<a href="https://stripe.com/">
							<img
								src={StripIcon}
								alt="stripe"
								style={{ width: 50, position: 'absolute' }}
							/>
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};

export default Header;
